<template>
  <div>
    <div>
      <button class="btn_primary" @click="goAdd">建立新文件欄位</button>
    </div>
    <div class="paper_list_nav flex">
      <div @click="paperNav(item)" v-for="(item, index) in paper_nav_list" :key="index"
        :class="is_page == item.val ? 'check' : false">
        {{ item.name }}
      </div>
    </div>
    <div class="paper_admin contain_white">
      <MyTransition :myName="'up'">
        <Popup v-if="popupStatus">
          <PopupCheck ref="popupCheck" v-if="popup == 'check'" :text="successText" @go="popupAction"
            @cancel="poupupEnter"></PopupCheck>
          <PopupSuccess v-if="popup == 'success'" :text="successText" @check="poupupEnter"></PopupSuccess>
          <PopupError v-if="popup == 'error'" :text="successText" @check="poupupEnter"></PopupError>
        </Popup>
      </MyTransition>
      <div class="paper_list">
        <div class="paper_item flex" v-for="(paper, index) in paper_list" :key="index">
          <div class="action flex">
            <Div @click="paperGo(paper, index)">
              <i class="el-icon-view"></i>
            </Div>
            <div class="action_upload">
              <label :for="`paper_upload${index}`">
                <i class="el-icon-upload"></i>
              </label>
              <input :id="`paper_upload${index}`" type="file" @change="paperUpload($event, paper)" />
            </div>
          </div>
          <div class="paper_name">{{ paper.file_name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.paper_list_nav {
  margin: 15px 0 0 10px;

  >div {
    cursor: pointer;
    padding: 8px 15px;
    background: #ccc;
    margin: 0 5px;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;

    &.check {
      color: #fff;
      background: #7e8ae2;
    }
  }
}

.paper {
  .paper_admin {

    // margin: 20px 0;
    .paper_uploade {
      width: 100%;

      label {
        cursor: pointer;
        display: block;
        width: 100%;
        text-align: center;
      }

      input {
        display: none;
      }
    }
  }
}

.paper_list {
  .paper_item {
    margin: 15px 0;
    padding: 15px 0;
    border-bottom: 1px solid #e1e3ee;
    align-items: center;

    &:last-child {
      border-bottom: none;
    }

    .paper_name {
      flex: 8.5;
    }
  }

  .action {
    flex: 1.5;

    >div {
      cursor: pointer;
      background: #efefef;
      padding: 4px;
      border-radius: 3px;
      margin: 0 10px 0 0;

      i {
        color: #777;
      }

      &:hover {
        transform: scale(1.1);
        color: #fff;
        background: var(--mainColor);

        i {
          color: #fff;
        }
      }
    }

    .action_upload {
      label {
        cursor: pointer;
      }

      input {
        display: none;
      }
    }
  }
}
</style>
<script>
export default {
  name: "paper_admin",
  data() {
    return {
      formData: new FormData(),
      paper_list: [],
      popupStatus: false,
      successText: null,
      popup: null,
      paper_nav_list: [
        {
          name: "施工單文件",
          val: "order",
        },
        {
          name: "其他",
          val: "other",
        },
      ],
      is_page: "order",
    };
  },
  computed: {
    storage() {
      return this.$http.base.storage;
    },
  },
  created() {
    this.getPaper();
  },
  methods: {
    goAdd() {
      this.$router.push({
        name: "paper_detailed",
      });
    },
    paperUpload(e, paper) {
      //每次上傳文件前, 先清空上一次的資料
      this.formData = new FormData();
      const name = e.target.files[0].name;
      this.formData.append("_method", "put");
      this.formData.append("file", e.target.files[0]); //放進上傳的檔案
      this.formData.append("file_name", paper.file_name);
      //分流
      if (this.is_page == "other") {
        this.$http.api.file
          .registerUpload(this.formData, paper.file_id)
          .then((res) => {
            this.popupStatus = true;
            this.successText = "上傳成功";
            this.popup = "success";
          })
          .catch((error) => {
            this.popupStatus = true;
            this.popup = "error";
            this.successText = "上傳失敗";
          });
      } else if (this.is_page == "order") {
        this.$http.api.file
          .postOrder(this.formData, paper.file_id)
          .then((res) => {
            this.popupStatus = true;
            this.successText = "上傳成功";
            this.popup = "success";
            this.getPaper();
          })
          .catch((error) => {
            this.popupStatus = true;
            this.popup = "error";
            this.successText = "上傳失敗";
          });
      }
    },
    getPaper() {
      //分流
      if (this.is_page == "other") {
        this.$http.api.file.registerDow().then((res) => {
          this.paper_list = res.data;
        });
      } else if (this.is_page == "order") {
        this.$http.api.file.getOrder().then((res) => {
          this.paper_list = res.data;
        });
      }
    },
    paperGo(item) {
      const num = Math.floor(Math.random() * 10);
      window.open(`${this.storage}${item.file_path}?v=${num}`, "_blank");
    },
    poupupEnter() {
      this.popupStatus = false;
      this.getPaper();
    },
    paperNav(item) {
      this.is_page = item.val;
    },
  },
  watch: {
    is_page() {
      this.getPaper();
    },
  },
};
</script>
